import WaitlistBanner from './WaitlistBanner';

export default WaitlistBanner;
